import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact'
import { customFacets } from '../config'

export default ({ isMobile }) => {
    const { filters, removeAll } = useProductFilters()

    return filters.length > 0 &&
        <div class={`product-facet__active-list tag-list ${isMobile ? 'hidden-tablet-and-up' : 'hidden-phone'}`}>
            {filters.map(filter => {
                const newFacet = customFacets.find(customFacet => customFacet.name === filter.name) || false;
                return <div class='tag'>
                        <button type="button" class="tag__icon tap-area" onClick={() => filter.remove()}>
                            <svg focusable="false" width="10" height="10" class="icon icon--close   " viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.2" fill="none"></path></svg>
                        </button>
                        {(newFacet.custom?.[filter.value]) ? newFacet.custom[filter.value] : filter.value}
                </div>
            })}
            {filters?.length > 1 && 
                <a href="javascript:void(0)"
                    class="tag-link link text--subdued"
                    onClick={removeAll}
                >
                    Clear All
                </a>
            }
        </div>
}